import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetSegmentos() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getSegmentos = useCallback(
        (descricao: string) => invocarApi({
            url: `v2/segmentos?Descricao=${'%' + descricao + '%'}&page=1`,
            method: 'GET',
            enviarTokenUsuario: false
        }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getSegmentos,
    };
}
